export default {
    SOMA: 1,
    SUBTRACAO: 2,
    DIVISAO: 3,
    MULTIPLICACAO: 4,
    MODULO: 5,
    EXPONENCIACAO: 6,
}